import { Link, useLocation } from 'react-router'
import styled from 'styled-components'
import textsData from '@/textData/OtpValidationTexts.json'
import { useUserLanguage } from '@/customHooks/useUserLanguage'
import envelopeIcon from '@/assets/rentmote-envelope-icon.svg'
import { pathURL } from '@/components/constants/urls'
import { OTPInputForm } from '../organism'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 600px;
  padding-top: ${({ theme }) => theme.spacing.lg};
  padding-bottom: ${({ theme }) => theme.spacing.lg};
`
const StyledText = styled.div`
  text-align: center;
  width: 300px;
  & > h1 {
    color: black;
  }
  & > p {
    word-wrap: normal;
    line-height: ${({ theme }) => theme.spacing.lg};
  }
`
export const OtpValidationTemplate = () => {
  const location = useLocation()
  const email = location.state?.email;

  const userLanguage = useUserLanguage();
  const texts = userLanguage === 'es' ? textsData.es : textsData.en

  return (
    <Wrapper>
      <div>
        <img src={envelopeIcon} width="128" alt="" />
      </div>
      <StyledText>
        <h1>{texts.title}</h1>
        <p>
          {texts.paragraph}
          &nbsp;
          <b>{email}</b>
        </p>
      </StyledText>
      
      <OTPInputForm />
      
      <div>
        <p>{texts.back.text} <Link to={`/${pathURL.LOGIN}`}>{texts.back.linkText}</Link></p>
      </div>
    </Wrapper>  
  )
}